import { appStore } from "@app/store/store"

export const getTimeString = date => {
	const locale = appStore.getState().core.locale
	if (!date) {
		return ""
	}
	return date.toLocaleTimeString(locale, {
		hourCycle: locale !== "de-DE" ? "h12" : "h24",
		hour: "2-digit",
		minute: "2-digit",
	})
}

export const getDateString = date => {
	return date.toLocaleDateString(appStore.getState().core.locale, {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	})
}

export const getLongDateString = date => {
	return date.toLocaleDateString(appStore.getState().core.locale, {
		weekday: "long",
		day: "2-digit",
		month: "long",
	})
}

/**
 * returns a localized price string. If you dont define a fraction the function will select the best format.
 * If you want always have a fraction then set friction to 2
 * @param {*} price
 * @param {*} fractions
 * @returns
 */
export const getPriceString = (price, fractions, rounded) => {
	const state = appStore.getState()

	if (rounded === undefined) {
		const zone = appStore.get("core.zone")
		const roundPrices = zone ? zone.roundPrices : undefined

		rounded = roundPrices
	}
	if (rounded) {
		price = Math.round(price)
	}

	if (!fractions) {
		fractions = price % 1 === 0 ? 0 : 2
	}

	return new Intl.NumberFormat(state.core.locale, {
		style: "currency",
		currency: state.core.currency,
		minimumFractionDigits: fractions,
	}).format(price)
}
